import React from "react";


const globalReplacements = {
    H2S: () => <span>H<sub>2</sub>S</span>,
    O3: () => <span>O<sub>3</sub></span>,
    NO2: () => <span>NO<sub>2</sub></span>,
    SO2: () => <span>SO<sub>2</sub></span>,
}

export const replaceJSX = (str, replacements) => {
    if (!str) {
        return "{MISSING_PHRASE}";
    }
    if (!replacements) {
        replacements = {}
    }
    replacements = {
        ...globalReplacements,
        ...replacements
    }

    let splitter = new RegExp("(<.*?>.*?<\/.*?>)")
    let matcher = new RegExp("<(.*?)>(.*?)<\/.*?>")

    return str.split(splitter).map((el, i) => {
        if (i % 2 === 0) {
            return el
        } else {
            let [_, tag, child] = el.match(matcher)
            let ElActual = replacements[tag]
            if (ElActual) {
                return <ElActual key={i}>{child.trim()}</ElActual>
            } else {
                return child.trim()
            }
        }
    })
}

const getBrowserLanguagePref = () => {
    return (navigator.languages && navigator.languages[0])
        || navigator.language
        || navigator.userLanguage;
}

const lang_prefix_to_locale = {
    "en": "en_us",
    "es": "es"
}

export const getLocale = () => {
    const ls_locale = window.localStorage.getItem("locale");
    if (ls_locale) {
        if (lang_prefix_to_locale.hasOwnProperty(ls_locale)){
            return lang_prefix_to_locale[ls_locale];
        }
    }

    const browser_language_pref = getBrowserLanguagePref();
    const lang_prefix = browser_language_pref.split('-')[0].toLowerCase();
    if (typeof lang_prefix_to_locale[lang_prefix] !== 'undefined') {
        return lang_prefix_to_locale[lang_prefix]
    }

    return "en_us";
}

export const setLocale = (locale) => {

    window.localStorage.setItem("locale", locale);
    window.location.reload(false)
}